import { render, staticRenderFns } from "./ScreenContentManage.vue?vue&type=template&id=2e1d3ba5&scoped=true"
import script from "./ScreenContentManage.vue?vue&type=script&lang=js"
export * from "./ScreenContentManage.vue?vue&type=script&lang=js"
import style0 from "./ScreenContentManage.vue?vue&type=style&index=0&id=2e1d3ba5&prod&scoped=true&lang=css"
import style1 from "./ScreenContentManage.vue?vue&type=style&index=1&id=2e1d3ba5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d3ba5",
  null
  
)

export default component.exports